var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Icons } from '../Icons';
export const FormGroup = (_a) => {
    var { id, className, autoFocus, label, error } = _a, props = __rest(_a, ["id", "className", "autoFocus", "label", "error"]);
    const textRef = useRef(null);
    useEffect(() => {
        if (textRef.current && autoFocus) {
            textRef.current.focus({ preventScroll: true });
        }
    }, []);
    return (React.createElement("div", { className: classNames(className, 'form-group') },
        React.createElement("label", { className: "form-group__label", htmlFor: id }, label),
        React.createElement("div", { className: "form-group__form-field" },
            React.createElement("input", Object.assign({ id: id, ref: textRef, className: classNames('form-group__form_field__input', {
                    'form-group__form_field__input-error': error,
                }), autoComplete: 'off' }, props))),
        error && (React.createElement("div", { className: "form-group__error" },
            React.createElement(Icons, { size: 16, iconName: "ic-ui-exclamation-sign" }),
            React.createElement("p", { className: "form-group__error-text" }, error)))));
};
//# sourceMappingURL=FormGroup.js.map